export default "__VITE_ASSET__DcW_$n6D__"